import React, { Component } from 'react';
import Home from './HomeComponent';
import Menu from './MenuComponent';
import About from './AboutUsComponent';
import Contact from './ContactComponent'
import { DishDetail } from './DishDetailComponent';
import Header from './HeaderComponent';
import Footer from './FooterComponent';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { postComment, postFeedback, fetchDishes, fetchComments, fetchPromos, fetchLeaders } from '../redux/ActionCreators';
import { actions } from 'react-redux-form';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const mapStateToProps = (state) => {
    //this object will later be available as props to this component
    return {
        dishes: state.dishes,
        comments: state.comments,
        promotions: state.promotions,
        leaders: state.leaders
    }
}

const matchDispatchToProps = (dispatch) => ({
    postComment: (dishId, rating, author, comment) => dispatch(postComment(dishId, rating, author, comment)),
    fetchDishes: () => dispatch(fetchDishes()),
    fetchComments: () => dispatch(fetchComments()),
    fetchPromos: () => dispatch(fetchPromos()),
    fetchLeaders: () => dispatch(fetchLeaders()),
    postFeedback: (values) => dispatch(postFeedback(values)),
    resetCustomerFeedBackForm: () => dispatch(actions.reset('customerFeedbackForm'))
})

class Main extends Component {

    constructor(props) {
        super()
    }

    componentDidMount() {
        this.props.fetchDishes();
        this.props.fetchPromos();
        this.props.fetchComments();
        this.props.fetchLeaders();
    }

    onDishSelect(dishId) {
        const selectedDish = this.props.dishes.filter(dish => dish.id === dishId);
        this.setState({
            selectedDish: selectedDish[0]
        });
    }

    render() {
        const HomePage = () => {
            const featuredDish = this.props.dishes.dishes.filter(dish => dish.featured)[0];
            const dishesLoading = this.props.dishes.isLoading;
            const dishesErrMessage = this.props.dishes.errMessage;
            const featuredPromotion = this.props.promotions.promotions.filter(promotion => promotion.featured)[0];
            const promosLoading = this.props.promotions.isLoading;
            const promosErrMessage = this.props.promotions.errMessage;
            const featuredLeader = this.props.leaders.leaders.filter(leader => leader.featured)[0];
            const leadersLoading = this.props.leaders.isLoading;
            const leadersErrMessage = this.props.leaders.errMessage;
            return (
                <Home dish={featuredDish} dishesLoading={dishesLoading} dishesErrMessage={dishesErrMessage}
                    promotion={featuredPromotion} promosLoading={promosLoading} promosErrMessage={promosErrMessage}
                    leader={featuredLeader} leadersLoading={leadersLoading} leadersErrMessage={leadersErrMessage} />
            );
        }

        const DishWithId = ({ match }) => { //match is a prop that is automatically added by Route
            const selectedDish = this.props.dishes.dishes.filter(
                dish => dish.id === parseInt(match.params.dishId, 10))[0];
            const dishLoading = this.props.dishes.isLoading;
            const dishErrMessage = this.props.dishes.errMessage;
            const selectedDishComments = this.props.comments.comments.filter(
                comment => comment.dishId === parseInt(match.params.dishId, 10));
            const commentsErrMessage = this.props.comments.errMessage;
            return (
                <DishDetail selectedDish={selectedDish} dishLoading={dishLoading}
                    dishErrMessage={dishErrMessage}
                    comments={selectedDishComments} commentsErrMessage={commentsErrMessage}
                    postComment={this.props.postComment} />
            );
        };

        return (
            <div>
                <Header {...this.props} switchTheme={this.props.switchTheme} currentTheme={this.props.currentTheme} />
                <TransitionGroup>
                    <CSSTransition key={this.props.location.key} classNames="page" timeout={300}>
                        <Switch>
                            <Route path="/home" component={HomePage} />
                            <Route exact path="/menu" component={() => <Menu dishes={this.props.dishes} />} />
                            <Route path="/menu/:dishId" component={DishWithId} />
                            <Route path="/contactus" component={() => <Contact
                                resetCustomerFeedBackForm={this.props.resetCustomerFeedBackForm}
                                postFeedback={this.props.postFeedback} />} />
                            <Route path="/aboutus" component={() =>
                                <About leaders={this.props.leaders.leaders} isLoading={this.props.leaders.isLoading} errMessage={this.props.leaders.errMessage} />} />
                            <Redirect to="/home" />
                        </Switch>
                    </CSSTransition>
                </TransitionGroup>
                <Footer />
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Main));
